import {
    Stack, Radio, RadioGroup,
    Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon,
    Box, Button, Text
} from "@chakra-ui/react"
import { createCheckoutSession } from "../../features/subscription/subscriptionSlice"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"


const PricingDisplay = ({ currencyCode, isLimitedSelected }) => {
    const annualPrice = {
        gbp: "£2.49",
        eur: "€2.79",
        usd: "$2.99",
    };
    const monthlyPrice = {
        gbp: "£3.99",
        eur: "€4.49",
        usd: "$4.79",
    };
    const limited1weekPrice = {
        gbp: "£2",
        eur: "€2.40",
        usd: "$2.60",
    };

    if (!isLimitedSelected)
        return (
            <div className="mb-3">
                <span className="display-4 fw-bold">{annualPrice[currencyCode]}</span>
                <span>/ mo. billed annually</span>
                <div className="small">
                    or {monthlyPrice[currencyCode]} / mo. billed monthly
                </div>
            </div>
        );

    if (isLimitedSelected)
        return (
            <div className="mb-3">
                <span className="display-4 fw-bold">{limited1weekPrice[currencyCode]}</span>
                <span> for 1 week</span>
                <div className="small">
                    does not renew automatically
                </div>
            </div>
        );
};

export default function PlanSelectionView() {

    const dispatch = useDispatch()

    const { redirectUrl, isLoading, isSuccess } = useSelector((state) => state.subscription)

    const [selectedPlanLookupKey, setSelectedPlanLookupKey] = useState('acp-annual')
    const [selectedCurrencyCode, setSelectedCurrencyCode] = useState('gbp')

    useEffect(() => {
        if (redirectUrl !== undefined && redirectUrl !== '')
            window.location.assign(redirectUrl)
    }, [redirectUrl])

    function selectPlanButtonPressed() {
        dispatch(createCheckoutSession({
            lookupKey: selectedPlanLookupKey,
            currencyCode: selectedCurrencyCode,
        }))
    }

    return (
        <div>
            <div className="card-body p-0">
                <div className="small text-uppercase fw-bold">
                    <i className="bi bi-star-fill text-warning" />
                    All-Country Pass
                </div>
                <PricingDisplay
                    currencyCode={selectedCurrencyCode}
                    isLimitedSelected={selectedPlanLookupKey === 'acp-limited-1week'}
                />
                <ul className="list-unstyled">
                    <li className="mb-2">
                        <i className="bi bi-check text-primary" />
                        <strong>Unlimited, worldwide access</strong>
                    </li>
                    <li className="mb-2">
                        <i className="bi bi-check text-primary" />
                        Access to all features
                    </li>
                    <li className="mb-2">
                        <i className="bi bi-check text-primary" />
                        No advertising
                    </li>
                    <li className="mb-2">
                        {selectedPlanLookupKey === 'acp-limited-1week' ? (
                            <i className="bi bi-x" />
                        ) : (
                            <i className="bi bi-check text-primary" />
                        )}
                        Unlimited 'Email Auto-Import'
                    </li>
                    <li className="mb-2">
                        {selectedPlanLookupKey === 'acp-limited-1week' ? (
                            <i className="bi bi-x" />
                        ) : (
                            <i className="bi bi-check text-primary" />
                        )}
                        Six map background options
                    </li>
                    <li className="mb-2">
                        <i className="bi bi-check text-primary" />
                        Access to Insights
                    </li>
                    <li className="mb-2">
                        <i className="bi bi-check text-primary" />
                        Public profile (optional)
                    </li>
                </ul>
            </div>
            <div className="">
                <Stack>
                    {/* Select monthly/annual */}
                    <RadioGroup onChange={setSelectedPlanLookupKey} value={selectedPlanLookupKey}>
                        <Stack>
                            <Radio value='acp-annual'>Annual</Radio>
                            <Radio value='acp-monthly'>Monthly</Radio>
                            {/* <Radio value='acp-limited-1week'>1-week access, does not renew automatically</Radio> */}
                        </Stack>
                    </RadioGroup>

                    <Button
                        onClick={() => selectPlanButtonPressed()}
                        colorScheme='blue'
                        variant='solid'
                        isLoading={isLoading || isSuccess}
                    >
                        Select
                    </Button>
                    {/* Select different currency */}
                    <Accordion allowToggle>
                        <AccordionItem>
                            <h2>
                                <AccordionButton>
                                    <Box as="span" flex='1' textAlign='left'>
                                        Select a different currency (€ or US$)
                                    </Box>
                                    <AccordionIcon />
                                </AccordionButton>
                            </h2>
                            <AccordionPanel pb={4}>
                                <RadioGroup onChange={setSelectedCurrencyCode} value={selectedCurrencyCode}>
                                    <Stack direction='row'>
                                        <Radio value='gbp'>£ (GBP)</Radio>
                                        <Radio value='eur'>€ (EUR)</Radio>
                                        <Radio value='usd'>$ (USD)</Radio>
                                    </Stack>
                                </RadioGroup>
                            </AccordionPanel>
                        </AccordionItem>
                    </Accordion>
                </Stack>
            </div>
        </div>
    )
}